import { dateSelectedFromFixedBar } from '@events/DLP';
import React from 'react';
import { format } from 'date-fns';
import ButtonPrimary from '../ButtonPrimary';

type Props = {
  localDate: Date | undefined;
  onConfirmClick: () => void;
};

export default function ConfirmSection({ localDate, onConfirmClick }: Props) {
  return (
    <div className="date-footer">
      <span className="inline-block mt-4 px-5">
        <p className="font-rp-pn-light text-sm">Selected Date:</p>
        {localDate && <div className="text-sm d:font-semibold">{format(localDate, 'MMMM d')}</div>}
      </span>
      <span className="inline-block w-2/5 float-right pb-5 mt-4 pr-5">
        <ButtonPrimary
          onClick={() => {
            if (localDate) {
              // Event
              dateSelectedFromFixedBar(localDate);
            }

            onConfirmClick();
          }}
          classes="h-10 text-base"
          isDisabled={!localDate}
        >
          Confirm
        </ButtonPrimary>
      </span>
    </div>
  );
}
